import React from 'react';

import { toast } from 'react-toastify';
import { sendEmailIntegration } from '../../../api/api';
import useThrottle from '../../../utils/use-throttle';
import IntegrationButton from './IntegrationButton';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

const EmailSendButton = ({ integration_id }) => {
  const handleErrors = (err) => {
    toast.error(err?.error ?? err, { hideProgressBar: true });
  };

  const sendForcedEmail = useThrottle(async () => {
    await sendEmailIntegration(
      integration_id,
      () => toast.success('Показания успешно отправлены на вашу почту!', { hideProgressBar: true, autoClose: false }),
      handleErrors
    );
  }, 500);

  return (
    <div className="flex flex-row justify-between items-center gap-x-2">
      <p className={'text-xs text-gray-500'}>Действия:</p>
      <IntegrationButton Icon={MailOutlineIcon} handleClick={sendForcedEmail} label={'Отправка показаний на почту'} />
    </div>
  );
};

export default EmailSendButton;
